const colorSchema = [
  {
    value: 'mathematics',
    colors: ['#3DD1FF', '#0B9DCC'],
  },
  {
    value: 'english',
    colors: ['#0B9DCC', '#3DD1FF'],
  },
  {
    value: 'french',
    colors: ['#006DA8', '#1995D3'],
  },
  {
    value: 'spanish',
    colors: ['#3B4195', '#006DA8'],
  },
  {
    value: 'social_studies',
    colors: ['#13D380', '#33F092'],
  },
  {
    value: 'science',
    colors: ['#2BA570', '#13D380'],
  },
  {
    value: 'physical_education',
    colors: ['#03AFBD', '#7EC9AA'],
  },
  {
    value: 'reading',
    colors: ['#8B278A', '#BC5FA5'],
  },
  {
    value: 'dance',
    colors: ['#BC2E94', '#F34EAC'],
  },
  {
    value: 'theatre',
    colors: ['#EE689D', '#EC98B9'],
  },
  {
    value: 'art',
    colors: ['#B61F4E', '#EA2865'],
  },
  {
    value: 'handwriting',
    colors: ['#FB940B', '#FFC21F'],
  },
  {
    value: 'music',
    colors: ['#E5CE34', '#FFE84E'],
  },
];

const getColorForSubject = (subject) => {
  const schema = colorSchema.find(item => item.value === subject);

  return schema ? schema.colors : ['#3FD1FF', '#089DCB'];
};

export { getColorForSubject };
